import React from "react";

const Plus = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#00BFA5"
        d="M8.377.698a7.426 7.426 0 10.005 14.853A7.426 7.426 0 008.377.698zm3.824 8.176H9.127v3.07h-1.5v-3.07h-3.07V7.375h3.07V4.304h1.5v3.07h3.07l.004 1.5z"
      ></path>
    </svg>
  );
};

export default Plus;
